"use client";

import React from "react";
import { BedDouble, Eye, ConciergeBell, Bed, Coffee, Wifi, BookOpen, Wind, Crown, Users, Car } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const rooms = [{
  id: 1,
  title: "Tractores 70 HP",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647820/img/tractor_110hp_power.png"
}, {
  id: 2,
  title: "Tractores 100 HP",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647820/img/tractor_100hp_heavy.png"
}, {
  id: 3,
  title: "Tractores 110 HP",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647820/img/tractor_70hp_field.png"
}, {
  id: 4,
  title: "Grúa Horquilla 4x4",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647820/img/forklift_4x4_rugged_terrain.png"
}, {
  id: 5,
  title: "Autocargables",
  image: "https://dear-fowl.10web.cloud/wp-content/uploads/2026/04/0c6d3052-d791-4368-81ea-6bc55a053f20.jpg?v=0vzonmb73a2"
}];
const roomAmenities = [{
  roomId: 1,
  iconName: "BedDouble",
  text: "Motor Diésel"
}, {
  roomId: 1,
  iconName: "Eye",
  text: "Tracción 4WD"
}, {
  roomId: 1,
  iconName: "ConciergeBell",
  text: "Arriendo Mensual"
}, {
  roomId: 2,
  iconName: "Bed",
  text: "Alto Torque"
}, {
  roomId: 2,
  iconName: "Coffee",
  text: "Cabina Climatizada"
}, {
  roomId: 2,
  iconName: "Wifi",
  text: "GPS Integrado"
}, {
  roomId: 3,
  iconName: "BedDouble",
  text: "Máxima Potencia"
}, {
  roomId: 3,
  iconName: "BookOpen",
  text: "Uso Intensivo"
}, {
  roomId: 3,
  iconName: "Wind",
  text: "Bajo Consumo"
}, {
  roomId: 4,
  iconName: "Crown",
  text: "Terreno Difícil"
}, {
  roomId: 4,
  iconName: "Users",
  text: "Carga Pesada"
}, {
  roomId: 4,
  iconName: "Car",
  text: "Despacho Incluido"
}, {
  roomId: 5,
  iconName: "BedDouble",
  text: "Carga Rápida"
}, {
  roomId: 5,
  iconName: "Users",
  text: "Versatilidad"
}, {
  roomId: 5,
  iconName: "Eye",
  text: "Visibilidad 360"
}];
const getIcon = (name: string) => {
  const commonClasses = "size-5 text-primary shrink-0";
  switch (name) {
    case "BedDouble":
      return <BedDouble className={commonClasses} />;
    case "Eye":
      return <Eye className={commonClasses} />;
    case "ConciergeBell":
      return <ConciergeBell className={commonClasses} />;
    case "Bed":
      return <Bed className={commonClasses} />;
    case "Coffee":
      return <Coffee className={commonClasses} />;
    case "Wifi":
      return <Wifi className={commonClasses} />;
    case "BookOpen":
      return <BookOpen className={commonClasses} />;
    case "Wind":
      return <Wind className={commonClasses} />;
    case "Crown":
      return <Crown className={commonClasses} />;
    case "Users":
      return <Users className={commonClasses} />;
    case "Car":
      return <Car className={commonClasses} />;
    default:
      return null;
  }
};
export default function SanctuariesOfPeace() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224804" id="nuestra-flota-agrícola" className="py-24 bg-background overflow-hidden dark" ref={ref}>
      <div className={`container mx-auto px-4 md:px-8 transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-6xl font-default font-bold text-foreground mb-6 tracking-wider uppercase">
            Nuestra Flota Agrícola
          </h2>
          <p className="text-muted-foreground text-xl font-default">
            Equipamiento de alto rendimiento para potenciar su producción. Arriendos flexibles desde 1 mes con despacho directo a su predio.
          </p>
        </div>

        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full relative">
          <CarouselContent className="-ml-4 md:-ml-6">
            {rooms.map((room, i) => <CarouselItem key={room.id} data-index={i} className="pl-4 md:pl-6 basis-full sm:basis-1/2 lg:basis-1/3 xl:basis-1/4">
                <div className="group relative overflow-hidden transition-transform duration-700 hover:scale-[1.02] cursor-pointer h-full rounded-sm shadow-xl">
                  <AspectRatio ratio={3 / 4} className="h-full">
                    <img src={room.image} alt={room.title} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-110" />
                    
                    {}
                    <div className="absolute inset-0 bg-primary/20 transition-colors duration-700 group-hover:bg-primary/40 mix-blend-multiply" />
                    
                    {}
                    <div className="absolute inset-0 bg-gradient-to-t from-background via-background/20 to-transparent opacity-90" />

                    {}
                    <div className="absolute inset-0 flex flex-col items-center justify-end p-8 text-center z-10">
                      
                      {}
                      <h3 className="text-2xl md:text-3xl font-default text-foreground font-bold tracking-tight transition-transform duration-500 ease-out group-hover:-translate-y-40">
                        {room.title}
                      </h3>

                      {}
                      <div className="absolute bottom-12 left-0 w-full pt-2 opacity-0 translate-y-8 transition-all duration-500 ease-out group-hover:opacity-100 group-hover:translate-y-0 flex flex-col items-center gap-4 pointer-events-none">
                        {roomAmenities.filter(a => a.roomId === room.id).map((amenity, j) => <div key={j} data-index={j} className="flex items-center gap-3 text-foreground/90">
                              {getIcon(amenity.iconName)}
                              <span className="text-xs tracking-widest uppercase font-bold font-mono">
                                {amenity.text}
                              </span>
                            </div>)}
                      </div>
                      
                    </div>
                  </AspectRatio>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="hidden md:block">
            <CarouselPrevious className="absolute -left-5 lg:-left-12 top-1/2 -translate-y-1/2 size-14 rounded-none border-2 border-primary text-primary bg-background/80 backdrop-blur-sm hover:bg-primary hover:text-primary-foreground transition-colors duration-300 shadow-2xl" />
            <CarouselNext className="absolute -right-5 lg:-right-12 top-1/2 -translate-y-1/2 size-14 rounded-none border-2 border-primary text-primary bg-background/80 backdrop-blur-sm hover:bg-primary hover:text-primary-foreground transition-colors duration-300 shadow-2xl" />
          </div>
        </Carousel>
      </div>
    </section>;
}